import React, { Fragment } from 'react';
import { string, bool, array, shape, object } from 'prop-types';

import { Tab } from 'semantic-ui-react';

import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';

import Author from '~/views/common/Author';
import SSO from '~/views/common/SSO';
import UsersStats from '~/views/common/UsersStats';
import Licenses from '~/views/common/Licenses';
import Address from '~/views/common/Address';
import Contact from '~/views/common/Contact';


const TabGeneral = ({
    data: {
        id,
        name,
        slug,
        product,
        author_id,
        // sometimes we don't get 'portal' back on the response
        portal: isPortal = false,
        private: isPrivate,
        closed,
        deleted,
        archived,
        licenses,
        vanity,
        description,
        organization_type,
        created,
        modified,
        contact,
        address,
        url,
        duns,
        phone,
        enable_private_collaboratory_feature,
        office_name,
        email,
        proxy_a_i,
        ai_reporting_chat_enabled,
        report_widget_tool_enabled,
        manage_fields_enabled,
    },
}) => (
    <Tab.Pane>
        <Section name="Info">
            <DataTable.Body>
                <DataTable.Row header="ID">{ id }</DataTable.Row>

                <DataTable.Row header="Name">{ name }</DataTable.Row>

                <DataTable.Row header="Product">{ product }</DataTable.Row>

                <DataTable.Row header="Type">{ organization_type }</DataTable.Row>

                <DataTable.Row header="Slug">{ slug }</DataTable.Row>

                <DataTable.Row header="Vanity">{ vanity }</DataTable.Row>

                <DataTable.Row header="DUNS">{ duns }</DataTable.Row>

                <DataTable.Row header="Description">{ description }</DataTable.Row>

                <DataTable.Row header="Phone">{ phone }</DataTable.Row>

                <DataTable.Row header="Main Office Name">{ office_name }</DataTable.Row>

                <DataTable.Row header="Main Office Email">{ email }</DataTable.Row>

                <DataTable.Row header="Website">{ url }</DataTable.Row>

                <DataTable.Row header="Created">{ created }</DataTable.Row>

                <DataTable.Row header="Modified">{ modified }</DataTable.Row>

                { /* Settings */ }
                <DataTable.Row header="Portal"><BoolIcon value={isPortal} /></DataTable.Row>

                <DataTable.Row header="Private"><BoolIcon value={isPrivate} /></DataTable.Row>

                <DataTable.Row header="Closed"><BoolIcon value={closed} /></DataTable.Row>

                <DataTable.Row header="Deleted"><BoolIcon value={deleted} /></DataTable.Row>

                <DataTable.Row header="Archived"><BoolIcon value={archived} /></DataTable.Row>
                { licenses && licenses.indexOf('1') !== -1 &&
                    <DataTable.Row header="Private Collaboratory"><BoolIcon value={enable_private_collaboratory_feature} /></DataTable.Row>
                }

                <DataTable.Row header="SmartFill AI (activity scraping + categorization)"><BoolIcon value={proxy_a_i} /></DataTable.Row>

                <DataTable.Row header="SmartLens AI (reporting chat)"><BoolIcon value={ai_reporting_chat_enabled} /></DataTable.Row>

                <DataTable.Row header="Outbound API Widget Tool (activity feed and reports)"><BoolIcon value={report_widget_tool_enabled} /></DataTable.Row>
                <DataTable.Row header="Manage Fields"><BoolIcon value={manage_fields_enabled} /></DataTable.Row>
            </DataTable.Body>
        </Section>

        <Author id={author_id} />

        { isPortal &&
            <Fragment>
                <Licenses licenses={licenses} systemPortal={licenses.indexOf('2') !== -1} />
                <SSO id={id} />
            </Fragment>
        }

        <UsersStats id={id} />

        <Contact contact={contact} />

        <Address address={address} />
    </Tab.Pane>
);

TabGeneral.propTypes = {
    data: shape({
        id: string.isRequired,
        name: string.isRequired,
        product: string.isRequired,
        author_id: string.isRequired,
        slug: string,
        portal: bool,
        private: bool,
        closed: bool,
        deleted: bool,
        archived: bool,
        allow_offline: bool,
        allow_private_groups: bool,
        allow_shoutbox: bool,
        show_impact_meter: bool,
        general_opportunity_enabled: bool,
        offline_opps_require_contact: bool,
        disable_email_notifications: bool,
        bypass_content_moderation: bool,
        student_graduation_required: bool,
        licenses: array,
        vanity: string,
        description: string,
        organization_type: string,
        created: string,
        modified: string,
        contact: object,
        address: object,
        enable_private_collaboratory_feature: bool,
        proxy_a_i: bool,
        ai_reporting_chat_enabled: bool,
        report_widget_tool_enabled: bool,
        manage_fields_enabled: bool,
    }).isRequired,
};

export default TabGeneral;
